import React from 'react';
import PagePanel from './PagePanel';

interface AppPagePanelProps {
    title: string;
    children?: React.ReactNode;
    className?: string;
    minWidth?: number;
    style?: React.CSSProperties;
    actions?: React.ReactNode;
}

/**
 * PagePanel variant for every panel on app content pages (InsightsPage,
 * PlanPage, and any future page). Applies the shared app-page-panel theme
 * (`.app-page-panel` in app.css — background tint and borderless title bar)
 * so that theme lives in one place and updates every panel at once; pass a
 * panel-specific `className` for anything unique to that panel.
 */
export default function AppPagePanel({ className = '', ...rest }: AppPagePanelProps) {
    return <PagePanel className={`app-page-panel ${className}`.trim()} {...rest} />;
}
